module.exports = __webpack_public_path__ + "media/images/emblems/GW-VS-Moerel-Filet-1eb5ab6fe98f4d58e5a852f77c603c1f.png";